const filterUnique = (value: any, index: number, self: any): boolean => {
    return value && self.indexOf(value) === index;
};

export default filterUnique;
